import { ADD_PROMO_CODE_ERROR, ADD_PROMO_CODE_REQUEST, ADD_PROMO_CODE_SUCCESS, ADD_TO_CART_SUCCESS, AUTH_LOGIN_REQUEST, AUTH_LOGIN_SUCCESS, AUTH_LOGOUT_SUCCESS, PREPARE_CHECKOUT_SUCCESS, FINALIZE_CHECKOUT_SUCCESS, REMOVE_FROM_CART_SUCCESS, REMOVE_PROMO_CODE_SUCCESS, TRACK_COLLECTION_CLICKED, TRACK_PRODUCT_CLICKED, TRACK_EMAIL_CAPTURED, TRACK_CART_VIEWED, CANCEL_SUBSCRIPTION_SUCCESS, SKIP_SUBSCRIPTION_SUCCESS, RESUME_SUBSCRIPTION_SUCCESS, PAUSE_SUBSCRIPTION_SUCCESS, CREATE_STOCK_REQUEST_SUCCESS, TRACK_PRODUCT_VIEWED, TRACK_VARIANT_CLICKED, ADD_SUBSCRIPTION_SUCCESS, PURCHASE_PREPAID_SUBSCRIPTION_SUCCESS, } from '../../actions/types';
const trackStartLogin = (chord, _state, action) => {
    const { email } = action.payload;
    chord.analytics.trackLoginStarted({ email });
};
const trackUserSignIn = (chord, state, action) => {
    const { email } = action.payload;
    const { id: userId } = state.user.data;
    chord.analytics.trackSignedIn({ userId: userId?.toString(), email });
};
const trackUserSignOut = (chord, _state, action, previousState) => {
    const { email } = action.payload;
    const { id: userId } = previousState.user.data;
    chord.analytics.trackSignedOut({ userId: userId?.toString(), email });
};
const addPromoCodeRequest = (chord, state, action) => {
    chord.analytics.trackCouponEntered({
        order: state.cart.data,
        couponCode: action.promoCode,
    });
};
const addPromoCodeSuccess = (chord, state, action) => {
    chord.analytics.trackCouponApplied({
        order: state.cart.data,
        couponCode: action.promoCode,
    });
};
const addPromoCodeError = (chord, state, action) => {
    chord.analytics.trackCouponDenied({
        order: state.cart.data,
        couponCode: action.promoCode,
        reason: action.reason,
    });
};
const removePromoCodeSuccess = (chord, state, action) => {
    chord.analytics.trackCouponRemoved({
        order: state.cart.data,
        couponCode: action.promoCode,
    });
};
const trackProductClicked = (chord, state, action) => {
    chord.analytics.trackProductClicked({
        order: state.cart.data,
        product: action.payload?.product,
    });
};
const trackCollectionClicked = (chord, _state, action) => {
    chord.analytics.trackCollectionClicked({
        collection: action.payload?.collection,
    });
};
const trackAddProduct = (chord, _state, action) => {
    chord.analytics.trackProductAdded({
        order: action.data,
        product: action.product,
        quantity: action.quantity,
        sku: action.sku,
    });
};
const trackRemoveProduct = (chord, _state, action, previousState) => {
    chord.analytics.trackProductRemoved({
        order: previousState.cart.data,
        product: action.product,
        quantity: action.quantity,
        sku: action.sku,
    });
};
const trackStockRequestCreated = (chord, state, action) => {
    chord.analytics.trackStockRequestCreated({
        order: state.cart.data,
        product: action.product,
        email: action.email,
    });
};
const trackEmailCaptured = (chord, _state, action) => {
    chord.analytics.trackEmailCaptured({
        emailCapture: action.payload?.emailCapture,
    });
};
const trackCartViewed = (chord, state, action) => {
    chord.analytics.trackCartViewed({
        order: state.cart.data,
        products: action.payload?.products,
    });
};
const trackStartCheckout = (chord, _state, action) => {
    chord.analytics.trackCheckoutStarted({
        order: action.data,
        products: action.products,
    });
};
const trackCompleteCheckout = (chord, _state, action) => {
    chord.analytics.trackCheckoutCompleted({
        order: action.cart,
        products: action.products,
        trackingIds: action.trackingIds,
    });
    chord.analytics.trackOrderCompleted({
        order: action.cart,
        products: action.products,
        trackingIds: action.trackingIds,
    });
};
const trackAddSubscription = (chord, _state, action) => {
    chord.analytics.trackSubscriptionAdded({
        order: action.data,
        lineItem: action.lineItem,
        subscriptionLineItem: action.subscriptionLineItem,
    });
};
const trackPurchasePrepaidSubscription = (chord, _state, action) => {
    chord.analytics.trackPrepaidSubscriptionAdded({
        order: action.cart,
        lineItem: action.lineItem,
        prepaidSubscription: action.prepaidSubscription,
    });
    chord.analytics.trackCheckoutStarted({
        order: action.cart,
    });
};
const trackCancelSubscription = (chord, _state, action) => {
    chord.analytics.trackSubscriptionCancelled({
        products: action.payload.products,
        subscription: action.payload.data,
    });
};
const trackSkipSubscription = (chord, _state, action) => {
    chord.analytics.trackSubscriptionSkipped({
        products: action.payload.products,
        subscription: action.payload.data,
    });
};
const trackResumeSubscription = (chord, _state, action) => {
    chord.analytics.trackSubscriptionResumed({
        products: action.payload.products,
        subscription: action.payload.data,
    });
};
const trackPauseSubscription = (chord, _state, action) => {
    chord.analytics.trackSubscriptionPaused({
        products: action.payload.products,
        subscription: action.payload.data,
    });
};
const trackProductViewed = (chord, state, action) => {
    chord.analytics.trackProductViewed({
        order: state.cart.data,
        product: action.payload?.product,
    });
};
const trackVariantClicked = (chord, state, action) => {
    chord.analytics.trackVariantClicked({
        order: state.cart.data,
        product: action.payload?.product,
    });
};
export const track = (chord, state, action, previousState) => {
    switch (action.type) {
        case AUTH_LOGIN_REQUEST:
            trackStartLogin(chord, state, action, previousState);
            break;
        case AUTH_LOGIN_SUCCESS:
            trackUserSignIn(chord, state, action, previousState);
            break;
        case AUTH_LOGOUT_SUCCESS:
            trackUserSignOut(chord, state, action, previousState);
            break;
        case ADD_PROMO_CODE_REQUEST:
            addPromoCodeRequest(chord, state, action, previousState);
            break;
        case ADD_PROMO_CODE_SUCCESS:
            addPromoCodeSuccess(chord, state, action, previousState);
            break;
        case ADD_PROMO_CODE_ERROR:
            addPromoCodeError(chord, state, action, previousState);
            break;
        case ADD_TO_CART_SUCCESS:
            trackAddProduct(chord, state, action, previousState);
            break;
        case REMOVE_FROM_CART_SUCCESS:
            trackRemoveProduct(chord, state, action, previousState);
            break;
        case TRACK_PRODUCT_CLICKED:
            trackProductClicked(chord, state, action, previousState);
            break;
        case TRACK_COLLECTION_CLICKED:
            trackCollectionClicked(chord, state, action, previousState);
            break;
        case TRACK_EMAIL_CAPTURED:
            trackEmailCaptured(chord, state, action, previousState);
            break;
        case CREATE_STOCK_REQUEST_SUCCESS:
            trackStockRequestCreated(chord, state, action, previousState);
            break;
        case TRACK_CART_VIEWED:
            trackCartViewed(chord, state, action, previousState);
            break;
        case PREPARE_CHECKOUT_SUCCESS:
            trackStartCheckout(chord, state, action, previousState);
            break;
        case FINALIZE_CHECKOUT_SUCCESS:
            trackCompleteCheckout(chord, state, action, previousState);
            break;
        case REMOVE_PROMO_CODE_SUCCESS:
            removePromoCodeSuccess(chord, state, action, previousState);
            break;
        case ADD_SUBSCRIPTION_SUCCESS:
            trackAddSubscription(chord, state, action, previousState);
            break;
        case PURCHASE_PREPAID_SUBSCRIPTION_SUCCESS:
            trackPurchasePrepaidSubscription(chord, state, action, previousState);
            break;
        case CANCEL_SUBSCRIPTION_SUCCESS:
            trackCancelSubscription(chord, state, action, previousState);
            break;
        case SKIP_SUBSCRIPTION_SUCCESS:
            trackSkipSubscription(chord, state, action, previousState);
            break;
        case RESUME_SUBSCRIPTION_SUCCESS:
            trackResumeSubscription(chord, state, action, previousState);
            break;
        case PAUSE_SUBSCRIPTION_SUCCESS:
            trackPauseSubscription(chord, state, action, previousState);
            break;
        case TRACK_PRODUCT_VIEWED:
            trackProductViewed(chord, state, action, previousState);
            break;
        case TRACK_VARIANT_CLICKED:
            trackVariantClicked(chord, state, action, previousState);
            break;
        default:
    }
};
